import { Card, CardContent } from "@/components/ui/card";
import { ChartContainer } from "@/components/ui/chart";
import { BarChart, CartesianGrid, ResponsiveContainer } from 'recharts';
import { ChartTitle } from "./ChartTitle";
import { CustomChartTooltip } from "./CustomChartTooltip";
import { ChartAxes } from "./ChartAxes";
import { ActivityBars } from "./ActivityBars";

interface ChartData {
  month: string;
  mensagens: number;
  agendamentos: number;
}

interface ActivityChartProps {
  data: ChartData[];
}

export function ActivityChart({ data }: ActivityChartProps) {
  return (
    <Card className="hover:shadow-md transition-all duration-200 animate-fade-in">
      <ChartTitle />
      <CardContent>
        <div className="h-[400px] w-full mt-4">
          <ChartContainer
            config={{
              mensagens: {
                label: "Mensagens",
                theme: {
                  light: "#4F46E5",
                  dark: "#6366F1",
                },
              },
              agendamentos: {
                label: "Agendamentos",
                theme: {
                  light: "#0EA5E9",
                  dark: "#38BDF8",
                },
              },
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data}
                margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                className="[&_.recharts-cartesian-grid-horizontal]:opacity-20 [&_.recharts-cartesian-grid-vertical]:opacity-20"
              >
                <CartesianGrid strokeDasharray="3 3" />
                <ChartAxes />
                <CustomChartTooltip />
                <ActivityBars />
              </BarChart>
            </ResponsiveContainer>
          </ChartContainer>
        </div>
      </CardContent>
    </Card>
  );
}